import { render, staticRenderFns } from "./CompleteOrganisationInfo.vue?vue&type=template&id=fa83e7c6&"
import script from "./CompleteOrganisationInfo.vue?vue&type=script&lang=js&"
export * from "./CompleteOrganisationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports